export function getShippingAddress(user) {
    return [user.AddressLineOne, user.AddressLineTwo,
        [user.CityName, user.StateName, user.PostalCode].filter(Boolean).join(', '),
        user.CountryName].filter(Boolean).join('\n');
}

export function getOrderNoteWithBillingAddress(billingAddress, orderNote) {
    return [`Billing address:\n${billingAddress.trim()}`, orderNote.trim()]
        .filter(Boolean).join('\n\n');
}
